import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { addcontext } from '../../ContextShare/ContextShare';
import AddNewEvent from './AddNewEvent';
import { Icon } from '@iconify/react';
import { DeleteEvent, EditEvent, GetEvent, GetEventListAdmin, hideEvent } from '../../Services/allApi';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import DeleteModal from '../DeleteModal';
import PopOver from '../../Components/PopOver';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import AdminPagination from '../../Components/AdminPagination';
import { toast } from 'react-toastify';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function TableEvents() {
    const { addEvent, setaddEvent } = useContext(addcontext)
    const {paginationStartIndexAD,setPaginationStartIndexAD}=useContext(addcontext)
    const {paginationEndIndexAD,setPaginationEndIndexAD}=useContext(addcontext)
    const [TotalEventCount,setTotalEventCount]=useState()
    const [isFiltered,setIsFiltered]=useState(false)
    const [editBox, setEditBox] = useState(false)
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const [errorMsg, setErrorMsg] = useState()

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },



    };
    const [idToDelete, setidToDelete] = useState()

    const [eventList, setEventList] = useState([])

    const [open4, setOpen4] = useState(false);
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);
    }
    const handleClose4 = () => {
        setOpen4(false);
    }
    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
        },
        {
            name: 'Event',
            selector: row => row.event,
            sortable: true,


        },
        {
            name: 'Uploader',
            selector: row => row.uploader,
            sortable: true,
        },
        {
            name: 'Created at',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated at',
            selector: row => row.updatedAt,
            sortable: true,
        },
        
        // {
        //     name: 'Visible',
        //     selector: row => row.visible,
        //     sortable: true,
        // },
        {
            name: 'Active',
            selector: row => row.active,
            sortable: true,
            minWidth: '120px', // Adjust the width as needed
            maxWidth: '140px',
        },

        // {
        //     name: 'Hide',
        //     selector: row => row.Hide,
        //     // sortable: true,
        // },
    ];
    useEffect(() => {
        geteventcall()
    }, [isEdited,paginationStartIndexAD,paginationEndIndexAD])

    const geteventcall = async () => {
        const result = await GetEventListAdmin(paginationStartIndexAD,paginationEndIndexAD)
        setEventList(result?.data?.data)
        // console.log(result?.data.data);
        setTotalEventCount(result?.data?.count)
        setErrorMsg(result?.response?.data?.message)

    }
    const hideOrUnhide = async (eventId) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await hideEvent({ pk: eventId }, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)
    }

    const deleteRow = async () => {
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await DeleteEvent(idToDelete, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }
    var data = []
    eventList && eventList?.map((item, index) => {
        const slno = index + 1
        const id = item.event_id;
        const event = item.event_name;
        const uploader = item.uploaded_by
        const createdAt = item.created_at?.slice(0, 10)
        const updatedAt = item.updated_at?.slice(0, 10)

        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
            <button className='' onClick={() => handleOpen4(item.event_id)} >Delete</button>
            <Icon icon="ic:outline-delete" className='text-lg' />
        </div>

        const visible = <div className='flex flex-row justify-center items-center'>
            <Icon icon={`${item.is_visible ? 'fa-solid:check-circle' : 'fa-solid:times-circle'}`} style={{ color: `${item.is_visible ? 'green' : 'red'}` }} className='text-lg' />
            <button onClick={() => hideOrUnhide(item.event_id)} className='ms-2 text-white px-2 py-1 rounded' style={{ backgroundColor: '#18A0FB', cursor: 'pointer' }} >{item.is_visible ? 'Hide' : 'Unhide'}</button>
        </div>
        const Action = <a style={{ color: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEdit(item)}>Edit</a>;
        const newObj = { slno, id, event, uploader, createdAt, updatedAt, active, visible, Action };
        data.push(newObj);
    })


    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()

    }

    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        // console.log(dataToEdit);
        const result = await EditEvent(dataToEdit, reqHeader)
        if(result.status==200){
        console.log(result);
        handleClose()
        setIsEdited(isEdited + 1)
        toast.success("Editing successfull")
        }else{
            const messageData = result?.response?.data?.message;
                // Check if messageData is an object
                const errorMessage = typeof messageData === 'object' && messageData !== null
                    ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
                    : messageData; // If it's a string, use it directly
                toast.error(errorMessage ?? "There was a problem editing event");
        }
    }



    return (
        <>

            {addEvent ?
                <AddNewEvent />
                :
                <>
                    {eventList?.length > 0 ?
                        <div className='flex flex-col gap-1'>
                        <DataTable
                            title={<div className='flex flex-row items-center'><span className='me-2'>Event List</span> <PopOver dataToDisplay={'Add Edit Events'} /></div>}
                            columns={columns}
                            data={data}
                            customStyles={customStyles}
                            // pagination
                            dense
                            highlightOnHover
                            selectableRowsHighlight
                            // paginationRowsPerPageOptions={[25, 50, 100, 200, 500]} // Options for users to change page size

                        // selectableRows
                        // progressPending
                        // progressComponent={<h1>load</h1>}
                        />
                       {TotalEventCount>25&&<AdminPagination count={TotalEventCount}/>}
                        </div>
                        :<>
                        {!errorMsg?<div className="flex justify-center items-center w-full h-full flex-col gap-5">
                            <SyncLoader
                                color="#3498db"
                                loading={true}
                                speedMultiplier={1}
                            />
                            <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>
                        </div>:
                        <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                        <p className="text-red-500 flex flex-row items-center text-lg gap-1"><span>{errorMsg}</span><Icon icon="material-symbols:error-outline" className='text-lg' /></p>
                        </div>
                        }
                        </>}
                </>
            }

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full '>

                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="eventname">Edit Event</label>
                            <input
                                id='eventname'
                                // placeholder='Add new event'
                                value={dataToEdit?.event_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, event_name: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="eventname">Edit Event Malayalam</label>
                            <input
                                id='eventname'
                                // placeholder='Add new event'
                                value={dataToEdit?.mal_event_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, mal_event_name: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>

                        </div>

                    </div>

                </Box>
            </Modal>

            <Modal
                open={open4}
                onClose={handleClose4}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style4}>
                    <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4} />
                </Box>
            </Modal>
        </>
    )
}

export default TableEvents